import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import InputAdornment from '@mui/material/InputAdornment';
import Popper from '@mui/material/Popper';
import * as React from 'react';
import { ChromePicker } from 'react-color';
import styled from 'styled-components';
import { InputComponentProps, ValueComponentProps } from '../../design-system';
import { TextField } from '../TextField';

export const Swatch = styled('div')`
  display: block;
  height: 20px;
  width: 20px;
  background-color: ${(p) => p.color};
  border-radius: 2px;
`;

export const Label = styled('span')`
  margin-left: ${(p) => p.theme.spacing(1)};
`;

export const ColorValue: React.FC<ValueComponentProps<string>> = ({ value }) => (
  <Box display="flex" alignItems="center">
    <Swatch color={value} />
    <Label>{value}</Label>
  </Box>
);

export const ColorInput: React.FC<InputComponentProps<string>> = ({
  disabled,
  error,
  helperText,
  name,
  onBlur,
  onChange,
  value,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  return (
    <>
      <TextField
        InputProps={{
          readOnly: true,
          startAdornment: (
            <InputAdornment position="start">
              <Swatch color={value} />
            </InputAdornment>
          ),
        }}
        disabled={disabled}
        error={error}
        fullWidth
        helperText={helperText}
        name={name}
        onBlur={onBlur}
        onClick={(event: React.MouseEvent<HTMLElement>) => setAnchorEl(anchorEl ? null : event.currentTarget)}
        value={value}
      />
      <Popper
        id="user-settings-color-picker"
        style={{ marginTop: '4px', marginBottom: '4px', zIndex: 9999 }}
        open={!!anchorEl}
        anchorEl={anchorEl}
        placement="bottom-start"
        transition
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={350}>
            <div>
              <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                <ChromePicker disableAlpha color={value} onChangeComplete={({ hex }) => onChange('color')(hex)} />
              </ClickAwayListener>
            </div>
          </Grow>
        )}
      </Popper>
    </>
  );
};
